// src/services/auditLogService.js
//
// Wraps /api/audit-logs/* backend calls for Super Admin view.
// Uses centralized api wrapper from the same folder.
import { api } from './api';

export const auditLogService = {
  // Fetches paginated and filterable logs
  getLogs: (params) => {
    const qs = new URLSearchParams();
    if (params.entity) qs.append('entity', params.entity);
    if (params.action) qs.append('action', params.action);
    if (params.page) qs.append('page', params.page);
    if (params.page_size) qs.append('page_size', params.page_size);
    
    const qsStr = qs.toString();
    return api.get('/api/audit-logs/' + (qsStr ? '?' + qsStr : ''));
  },

  // Fetches full history for a specific record (e.g. one specific contract)
  getEntityHistory: (entity, entityId) =>
    api.get('/api/audit-logs/entity/' + entity + '/' + entityId),

  // Generates the URL for Excel export
  getExportUrl: (entity, action) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    let url = baseUrl + '/api/audit-logs/export/excel';
    
    const qs = new URLSearchParams();
    if (entity) qs.append('entity', entity);
    if (action) qs.append('action', action);
    
    const qsStr = qs.toString();
    return url + (qsStr ? '?' + qsStr : '');
  }
};